import React from 'react';

const EmptyCardListIcon = () => (
  <svg width="248" height="112" viewBox="0 0 248 112" fill="none">
    <rect
      x="0.38874"
      y="0.38874"
      width="223.223"
      height="63.2225"
      rx="4.27614"
      fill="white"
      stroke="#EAEAED"
      strokeWidth="0.77748"
    />
    <rect x="48" y="18" width="160" height="10" rx="3.10992" fill="#EAEAED" />
    <rect x="48" y="36" width="97.2973" height="10" rx="3.10992" fill="#EAEAED" />
    <path
      d="M39 32C39 38.0751 34.0751 43 28 43C21.9249 43 17 38.0751 17 32C17 25.9249 21.9249 21 28 21C34.0751 21 39 25.9249 39 32Z"
      fill="#EAEAED"
      stroke="white"
      strokeWidth="2"
    />
    <circle cx="28" cy="32" r="11.5" stroke="#4200FC" />
    <rect
      x="24.3887"
      y="48.3887"
      width="223.223"
      height="63.2225"
      rx="4.27614"
      fill="white"
      stroke="#EAEAED"
      strokeWidth="0.77748"
    />
    <rect x="72" y="66" width="160" height="10" rx="3.10992" fill="#EAEAED" />
    <rect x="72" y="84" width="97.2973" height="10" rx="3.10992" fill="#EAEAED" />
    <path
      d="M63 80C63 86.0751 58.0751 91 52 91C45.9249 91 41 86.0751 41 80C41 73.9249 45.9249 69 52 69C58.0751 69 63 73.9249 63 80Z"
      fill="#EAEAED"
      stroke="white"
      strokeWidth="2"
    />
    <circle cx="52" cy="80" r="11.5" stroke="#2E92E6" />
  </svg>
);

export default EmptyCardListIcon;
